import { IExternalLinkModel } from '@api/models';
import { deleteExternalLink } from '@api/services/document.service';
import { useMutation } from '@tanstack/react-query';

interface DeleteExternalLinkOptions {
    clientId: string;
    externalLink: IExternalLinkModel;
}

const useDeleteExternalLinkForm = (options: DeleteExternalLinkOptions) => {
    const { clientId, externalLink } = options;

    const deleteExternalLinkMutation = useMutation(() => deleteExternalLink(clientId, externalLink._id));

    const submit = async () => {
        await deleteExternalLinkMutation.mutateAsync();
    };

    return {
        isLoading: deleteExternalLinkMutation.isPending,
        submit,
    };
};

export default useDeleteExternalLinkForm;
